// Typelizer digest c0d0a6630b9cc9637f3d21d4efec5422
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /admin/productions/:production_id/script_imports/preview */
  preview: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/script_imports/preview', params, options),
    method: 'post',
  }),

  /** POST /admin/productions/:production_id/script_imports */
  create: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/script_imports', params, options),
    method: 'post',
  }),

  /** GET /admin/productions/:production_id/script_imports/new */
  new: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/script_imports/new', params, options),
    method: 'get',
  }),
}
